import { WinGISMap } from "../../createMap";
import { getExcludedLayerIds } from "./initializeExcludedLayerIds";
import { conditionalMapOptions } from "../../util/importConditions";


export function getIdentifyParameters(event, layer, params) {

    return constructIdentifyParameters(event, layer, params); 
 

  }

  function constructIdentifyParameters (event,  layer, params) {
    let identifyParameters = {};
  
    let LayerIdenParams = conditionalMapOptions?.layers[layer.title]?.identifyParameters;  
  
    if (LayerIdenParams) {
      for (const [key, value] of Object.entries(LayerIdenParams)) {
        identifyParameters[key] = value; 
      }
    } else if (LayerIdenParams === false) {
      return false;
    }
  
    if(params) {
      for (const [key, value] of Object.entries(params)) {
        identifyParameters[key] = value;
      }
    }
  
    if (!identifyParameters.layerIds) {
      identifyParameters.layerIds = getVisibleSublayerIds(layer);
  
      if (LayerIdenParams?.excludedLayers) {
        if (!LayerIdenParams.excludedLayerIds) {
          console.error("Error getting excluded layers.");
          getExcludedLayerIds();
        }
        for (const excludedLayerId of LayerIdenParams.excludedLayerIds) {
          const index = identifyParameters.layerIds.indexOf(excludedLayerId);
          if (index > -1) {
            identifyParameters.layerIds.splice(index, 1);
          }
        }
      }
    }
  
    identifyParameters.returnGeometry = true; 
    if (event.mapPoint) {
      identifyParameters.geometry = event.mapPoint;
    }
  
    if (!identifyParameters.layerOption) {
      identifyParameters.layerOption = "visible";
    }
  
    if (!identifyParameters.tolerance) {
      identifyParameters.tolerance = 1; 
    }
    identifyParameters.width = WinGISMap.view.width;
    identifyParameters.height = WinGISMap.view.height;
    identifyParameters.mapExtent = WinGISMap.view.extent;
  
    return identifyParameters; 
  }
  
  function getVisibleSublayerIds(layer) {
    let sublayerArray = [];
    function exploreLayers(layer) {
      layer.sublayers.forEach(sublayer => {
        if (sublayer.visible) {
          if (sublayer.sublayers && sublayer.sublayers.length > 0) {
            exploreLayers(sublayer);
          } else {
            sublayerArray.push(sublayer.id);
          }
        } else {
          sublayerArray.push(-1);
        }
      });
    }
    exploreLayers(layer);
    return sublayerArray.filter(e => e !== -1);
  }